import React from 'react';
import {
  Flex,
  Icon,
  FlexProps,
  Text,
  Box,
  useDisclosure,
  Collapse,
  Tooltip,
} from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';
import { CaretDown } from 'phosphor-react';
import { IMenuIcon } from '../../routes/private.routes';

interface NavItemProps extends FlexProps {
  icon: IMenuIcon;
  parentHref: string;
  parentName: string;
  childrenMenus: any;
  openMenu: boolean;
}

export function NavItemMenu({
  icon,
  parentHref,
  parentName,
  childrenMenus,
  openMenu,
  ...rest
}: NavItemProps) {
  const { pathname } = useLocation();
  const algumFilhoAtivo = childrenMenus.some(
    (s: any) => pathname === s.path || pathname.includes(`${s.path}/`),
  );
  const ativo = algumFilhoAtivo || pathname === parentHref || pathname.includes(`${parentHref}/`);
  // Abre já expandido quando a tela atual é de um dos filhos
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: algumFilhoAtivo });

  return (
    <Box my="2px">
      <Tooltip label={parentName} placement="right" hasArrow isDisabled={openMenu}>
        <Flex
          w="full"
          h="40px"
          px={openMenu ? 3 : 0}
          gap={3}
          align="center"
          justify={openMenu ? 'flex-start' : 'center'}
          borderRadius="12px"
          cursor="pointer"
          color={ativo ? '#1B88F5' : '#475569'}
          transition="background 0.18s ease, color 0.18s ease"
          _hover={{ bg: '#F5F8FB', color: ativo ? '#1B88F5' : '#0F172A' }}
          onClick={onToggle}
          {...rest}
        >
          <Icon w="20px" h="20px" flexShrink={0} as={icon} />
          {openMenu && (
            <>
              <Text
                flex={1}
                fontFamily="heading"
                fontWeight={ativo ? 700 : 500}
                fontSize="13.5px"
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                title={parentName}
              >
                {parentName}
              </Text>
              <Box
                as={CaretDown}
                boxSize="14px"
                flexShrink={0}
                color="#94A3B8"
                transition="transform 0.2s ease"
                transform={isOpen ? 'rotate(180deg)' : undefined}
              />
            </>
          )}
        </Flex>
      </Tooltip>
      <Collapse in={isOpen && openMenu} animateOpacity>
        <Box ml="21px" pl="10px" my="2px" borderLeft="1px solid" borderColor="#E2E8F0">
          {childrenMenus.map(submenu => {
            const selected = pathname === submenu.path || pathname.includes(`${submenu.path}/`);
            return (
              <Link key={submenu.name} to={submenu.path}>
                <Flex
                  w="full"
                  h="34px"
                  my="2px"
                  px={2}
                  gap={2}
                  align="center"
                  borderRadius="10px"
                  cursor="pointer"
                  bg={selected ? '#EAF4FF' : 'transparent'}
                  color={selected ? '#1B88F5' : '#64748B'}
                  transition="background 0.18s ease, color 0.18s ease"
                  _hover={{
                    bg: selected ? '#E1EFFF' : '#F5F8FB',
                    color: selected ? '#1B88F5' : '#0F172A',
                  }}
                >
                  {submenu.icon && <Icon w="17px" h="17px" flexShrink={0} as={submenu.icon} />}
                  <Text
                    fontWeight={selected ? 700 : 500}
                    fontSize="13px"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    title={submenu.name}
                  >
                    {submenu.name}
                  </Text>
                </Flex>
              </Link>
            );
          })}
        </Box>
      </Collapse>
    </Box>
  );
}
